import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06022707"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary-overview" }
const _hoisted_2 = { class: "summary-overview-left" }
const _hoisted_3 = { class: "summary-item" }
const _hoisted_4 = { class: "summary-item-label" }
const _hoisted_5 = { class: "summary-item-value" }
const _hoisted_6 = { class: "summary-item" }
const _hoisted_7 = { class: "summary-item-label" }
const _hoisted_8 = { class: "summary-item-value" }
const _hoisted_9 = { class: "summary-item" }
const _hoisted_10 = { class: "summary-item-label" }
const _hoisted_11 = { class: "cash-breakdown" }
const _hoisted_12 = { class: "cash-breakdown-label" }
const _hoisted_13 = { class: "cash-breakdown-value" }
const _hoisted_14 = {
  class: "summary-item-value",
  style: {"margin-left":"4px"}
}

import { computed, ref, watch } from 'vue'
import { InfoFilled } from '@element-plus/icons-vue'
import type { CashBreakdownData, SummaryOverviewData } from './hooks/useAccountDetail'


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryOverview',
  props: {
    activeTopTab: null,
    summaryOverviewData: null,
    cashBreakdownData: null
  },
  setup(__props: any) {

const props = __props as {
  activeTopTab: string
  summaryOverviewData: SummaryOverviewData
  cashBreakdownData: CashBreakdownData
};



const summaryCurrency = ref<'HKD' | 'USD'>('HKD')
const summaryCurrencyOptions = [
  { label: '港币 HKD', value: 'HKD' },
  { label: '美元 USD', value: 'USD' }
]

const currentSummaryOverview = computed(() => props.summaryOverviewData[summaryCurrency.value])

const currentCashBreakdown = computed(() => props.cashBreakdownData[summaryCurrency.value])


return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "总资产（" + _toDisplayString(summaryCurrency.value) + "）", 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(currentSummaryOverview).totalAsset), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, "总购买力（" + _toDisplayString(summaryCurrency.value) + "）", 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(currentSummaryOverview).totalBuyingPower), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, [
          _createTextVNode(" 总现金（" + _toDisplayString(summaryCurrency.value) + "） ", 1),
          _createVNode(_component_el_popover, {
            placement: "bottom-start",
            trigger: "hover",
            width: 320,
            "popper-class": "cash-breakdown-popper"
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_icon, { class: "summary-item-tip" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(InfoFilled))
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentCashBreakdown), (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.label,
                    class: "cash-breakdown-item"
                  }, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(item.label), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(item.value), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(currentSummaryOverview).totalCash), 1)
      ])
    ]),
    _createVNode(_component_el_select, {
      modelValue: summaryCurrency.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((summaryCurrency).value = $event)),
      placeholder: "请选择",
      class: "summary-overview-currency-select"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(summaryCurrencyOptions, (option) => {
          return _createVNode(_component_el_option, {
            key: option.value,
            label: option.label,
            value: option.value
          }, null, 8, ["label", "value"])
        }), 64))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})